import { MAINTENANCE_MODE, MaintenanceComponent } from '@localina/core';
import { i18n } from 'i18next';
import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { MemoryRouter as Router, Route, Routes } from 'react-router-dom';
import { Store } from 'redux';
import { AppProvider } from '../contexts';
import { Path } from '../enums';
import { IApplicationStore } from '../interfaces';
import CancelReservation from './CancelReservation/CancelReservation';
import Error from './Error/Error';
import Menu from './Menu/Menu';
import Reservation from './Reservation/Reservation';
import Start from './Start/Start';

interface IProps {
    store: Store<IApplicationStore>;
    i18n: i18n;
}

class App extends React.Component<IProps> {
    elementDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        /* eslint-disable no-console */
        console.error('MyLocalina Widget error:', error, errorInfo);
    }

    render() {
        if (MAINTENANCE_MODE) {
            return (
                <I18nextProvider i18n={this.props.i18n}>
                    <MaintenanceComponent />
                </I18nextProvider>
            );
        }
        return (
            <Provider store={this.props.store}>
                <I18nextProvider i18n={this.props.i18n}>
                    <Router>
                        <AppProvider>
                            <Routes>
                                <Route path={Path.RESTAURANT_MENU} element={<Menu />} />
                                <Route path={Path.CANCEL_RESERVATION} element={<CancelReservation />} />
                                <Route path={Path.START} element={<Start />} />
                                <Route path={Path.ERROR} element={<Error />} />
                                <Route path={Path.RESERVATION} element={<Reservation />} />
                            </Routes>
                        </AppProvider>
                    </Router>
                </I18nextProvider>
            </Provider>
        );
    }
}

export default App;
